import Card from './Card';
import './App.css';

function App() {
  return (
    <div className="App">
     <Card/>
    </div>
  );
}

export default App;
